export const mergeNonEmptyFields = <T extends Record<string, any>>(source: T = {} as T, target: Partial<T>): T => {
    const result: Record<string, any> = { ...target };

    for (const [key, value] of Object.entries(source)) {
        if (isNullOrUndefined(result[key]) && value != null && value !== '') {
            result[key] = value;
        }
    }

    return result as T;
};

const isNullOrUndefined = (value: any): boolean => {
    return [null, undefined].includes(value);
};
